import { StyledEngineProvider } from "@mui/material";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import { ColorModeProvider } from "./design/ColorModeProvider";
import AppSnackbar from "./grading/components/AppSnackbar/AppSnackbar";
import { GradingHome } from "./grading/home";
import { InviteHome } from "./grading/pages/Invite/InviteHome";
import AuthCallbackPage from "./grading/pages/Login/AuthCallbackPage";
import WebStationPage from "./grading/pages/Station/WebStationPage";

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ColorModeProvider>
        <Router>
          <Switch>
            <Route exact path="/">
              <Redirect to="/grading/today" />
            </Route>
            {/* Console pages: sessions, classes, reports, districts, staff, profile. "/grading" is the mount point
                every deep link uses; the legacy grading-platform pages behind it were removed. */}
            <Route path="/grading" component={GradingHome} />
            <Route path="/invite" component={InviteHome} />
            <Route path="/station" component={WebStationPage} />
            <Route path="/auth/callback" component={AuthCallbackPage} />
            <Route>
              <Redirect to="/grading" />
            </Route>
          </Switch>
        </Router>
        <AppSnackbar />
      </ColorModeProvider>
    </StyledEngineProvider>
  );
}

export default App;
